import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Layout, Row } from 'antd';
import { get } from 'lodash';
import queryString from 'query-string';

import ResellerServices from 'services/reseller';

import { PageSpinner } from 'components/page-spinner';

import { errHandling } from 'utils';

import {
  Addresses,
  Cashback,
  Documents,
  Informations,
  Orders,
  Withdrawal,
} from './sections';

import './style.scss';

const { Content } = Layout;

export function DetailReseller({
  accepted = true,
  cashback = true,
  docs = true,
  id = '',
  info = true,
  loading = false,
  orders = true,
  storeAddress = true,
  withdrawal = false,
  value = {},
}) {
  const [orderList, setOrderList] = useState([]);
  const [orderLoad, setOrderLoad] = useState(false);
  const [orderNext, setOrderNext] = useState(0);
  const [orderPage, setOrderPage] = useState(1);

  const [cashbackData, setCashbackData] = useState({});
  const [cashbackList, setCashbackList] = useState([]);
  const [cashbackLoad, setCashbackLoad] = useState(false);
  const [cashbackNext, setCashbackNext] = useState(0);
  const [cashbackPage, setCashbackPage] = useState(1);

  const [withdrawalList, setWithdrawalList] = useState([]);
  const [withdrawalLoad, setWithdrawalLoad] = useState(false);
  const [withdrawalNext, setWithdrawalNext] = useState(0);
  const [withdrawalPage, setWithdrawalPage] = useState(1);

  const location = useLocation();
  const parsed = queryString.parse(location.search);

  const {
    application_status = '',
    personal_address = {},
    store_name = '',
  } = value;

  async function loadMoreCashback() {
    setCashbackLoad(true);
    try {
      const { data } = await ResellerServices.getResellerCashback({
        cursor: cashbackPage,
        limit: 5,
        id,
      });
      const cashbackData = get(data, 'data.detail', {});
      const cashbackList = get(data, 'data.activities', []);
      const cursor = get(data, 'metadata.next_cursor', -1);

      setCashbackList((prevState) => [...prevState, ...cashbackList]);
      setCashbackNext(cursor);
      setCashbackPage((prevState) => prevState + 1);
      setCashbackData(cashbackData);
    } catch (error) {
      errHandling(error);
    } finally {
      setCashbackLoad(false);
    }
  }

  async function loadMoreOrder(isLoadMore) {
    isLoadMore && setOrderLoad(true);
    try {
      const { data } = await ResellerServices.getResellerOrder({
        cursor: isLoadMore ? orderPage + 1 : 1,
        order_status: parsed['order_status'],
        limit: 5,
        id,
      });
      const cursor = get(data, 'metadata.next_cursor', -1);
      const orderList = get(data, 'data', []);

      if (isLoadMore) {
        setOrderList((prevState) => [...prevState, ...orderList]);
        setOrderPage((prevState) => prevState + 1);
      } else {
        setOrderList(orderList);
        setOrderPage(1);
      }
      setOrderNext(cursor);
    } catch (error) {
      errHandling(error);
    } finally {
      setOrderLoad(false);
    }
  }

  async function fetchOrderForDownload() {
    const { data } = await ResellerServices.getOrderReport(id, {
      statuses: parsed['order_status'],
    });
    const orderData = get(data, 'data', []);
    return orderData
  }

  async function loadMoreWithdrawal(isLoadMore) {
    isLoadMore && setWithdrawalLoad(true);
    try {
      const { data } = await ResellerServices.getResellerWithdrawal({
        page: isLoadMore ? withdrawalPage + 1 : 1,
        withdrawal_status: parsed['withdrawal_status'],
        id,
      });
      const cashbackList = get(data, 'data.activities', []);
      const temp = cashbackList.filter((el) => el.activity === 'withdrawal');
      const withdrawalList = temp.map((el) => el.withdrawal);
      const cursor = get(data, 'metadata.next_cursor', -1);
      if (isLoadMore) {
        setWithdrawalList((prevState) => [...prevState, ...withdrawalList]);
        setWithdrawalPage((prevState) => prevState + 1);
      } else {
        setWithdrawalList(withdrawalList);
        setWithdrawalPage(1);
      }
      setWithdrawalNext(cursor);
    } catch (error) {
      errHandling(error);
    } finally {
      isLoadMore && setWithdrawalLoad(false);
    }
  }

  async function fetchWithdrawalForDownload() {
    const { data } = await ResellerServices.getWithdrawalReport(id, {
      withdrawal_status: parsed['withdrawal_status'],
    });

    const withdrawalData = get(data, 'data', []);
    return withdrawalData
  }

  useEffect(() => {
    loadMoreCashback();
    if (orders) loadMoreOrder();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    loadMoreWithdrawal(false);
    // eslint-disable-next-line
  }, [parsed['withdrawal_status']]);

  useEffect(() => {
    loadMoreOrder(false);
    // eslint-disable-next-line
  }, [parsed['order_status']]);

  if (loading) {
    return <PageSpinner />;
  }

  return (
    <Content className="pageContent pd-reseller-detail">
      <Row>
        {info && (
          <Informations
            accepted={accepted}
            bank={cashbackData}
            id={id}
            value={value}
          />
        )}
        {docs && application_status && <Documents value={value} />}
        {storeAddress && application_status && (
          <Addresses addresses={personal_address} store_name={store_name} />
        )}
        {cashback && accepted && (
          <Cashback
            cashbackData={cashbackData}
            cashbackList={cashbackList}
            cashbackLoad={cashbackLoad}
            cashbackNext={cashbackNext}
            loadMoreCashback={loadMoreCashback}
          />
        )}
        {!withdrawal && accepted && (
          <Withdrawal
            fetchWithdrawalForDownload={fetchWithdrawalForDownload}
            loadMoreWithdrawal={loadMoreWithdrawal}
            withdrawalList={withdrawalList}
            withdrawalLoad={withdrawalLoad}
            withdrawalNext={withdrawalNext}
          />
        )}

        {orders && accepted && (
          <Orders
            fetchOrderForDownload={fetchOrderForDownload}
            loadMoreOrder={loadMoreOrder}
            orderList={orderList}
            orderLoad={orderLoad}
            orderNext={orderNext}
          />
        )}
      </Row>
    </Content>
  );
}

export default { DetailReseller };
